/**
 * The open-arrow of a StreamLain dropdown trigger: the outlined down chevron,
 * never a filled triangle glyph.
 */
import { ArrowDownSmallIcon } from '@blocksuite/icons/rc';
import type { FC } from 'react';

import * as styles from './dropdown-chevron.css';

export const DropdownChevron: FC = () => (
  <ArrowDownSmallIcon className={styles.dropdownChevron} aria-hidden="true" />
);
